import React from 'react';
import { compose, pick } from 'ramda';
import { withProps } from 'recompose';
import { usePortletConfig } from 'js/components/system/Portlet';
import ExpandableSection from '../common/ExpandableSection';
import FadeInContainer from '../common/FadeInContainer';
import { withEmptyState } from '../common/EmptyState';
import Card from './SliderCard';
import withSkeleton from './withSkeleton';
import style from './index.scss';

export const OverflowSlider = compose(
    withSkeleton,
    withEmptyState
)(({ leaderboards }) => (
    <FadeInContainer className={style.container}>
        <div className={style.overflowSlider}>
            {leaderboards.map(board => <Card key={board.leaderboardId} {...board} />)}
        </div>
    </FadeInContainer>
));

export const OverflowSliderExpandable = ({ leaderboards }) => (
    <ExpandableSection>
        <OverflowSlider leaderboards={leaderboards} />
    </ExpandableSection>
);

export default withProps(
    () => pick(['displayInExpandView'], usePortletConfig())
)(({ displayInExpandView, ...rest }) => {
    return displayInExpandView
        ? <OverflowSlider {...rest} />
        : <OverflowSliderExpandable {...rest} />;
});
